import React from 'react';

function CatTransportation() {
  return (
    <div className="container mt-5">
      <h1 className="text-center mb-4">猫咪托运</h1>
      <div className="row">
        <div className="col-md-8 offset-md-2">
          <div className="card mb-4">
            <div className="card-body">
              <h5 className="card-title">安全可靠的猫咪托运服务</h5>
              <p className="card-text">
                我们提供专业的猫咪托运服务，确保您的爱猫在旅途中得到最好的照顾。无论是城市间的短途移动，还是跨国的长途旅行，我们都能为您的猫咪提供安全舒适的托运体验。
              </p>
              <h6 className="mt-3">我们的服务特点：</h6>
              <ul className="list-group list-group-flush mb-3">
                <li className="list-group-item">专业的宠物托运箱，确保猫咪旅途安全</li>
                <li className="list-group-item">全程温度控制，避免猫咪受到天气影响</li>
                <li className="list-group-item">定时喂食和照料，保证猫咪舒适</li>
                <li className="list-group-item">实时位置追踪，随时了解猫咪状态</li>
                <li className="list-group-item">专业兽医随行，应对紧急情况</li>
              </ul>
            </div>
          </div>
          
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">托运流程</h5>
              <ol className="list-group list-group-numbered mb-3">
                <li className="list-group-item">在线预约托运服务</li>
                <li className="list-group-item">提供猫咪健康证明和相关文件</li>
                <li className="list-group-item">我们上门接收猫咪</li>
                <li className="list-group-item">全程追踪猫咪状态</li>
                <li className="list-group-item">安全送达目的地</li>
              </ol>
              <button className="btn btn-primary">预约托运</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CatTransportation;
